<template>
  <main class="main page-inside text-page">
    <div class="main-wrapper">
      <div class="section hero-section">
        <div class="wrapper">
          <div class="wrapper-top">
            <div class="title-container">
              <button class="back-page" @click="$parent.back">
                <img class="back-img" src="./../img/back-page.svg" />
              </button>
              <div
                class="title weight-600"
                v-if="$parent.textPageTitle"
                v-html="$parent.textPageTitle"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="section text-section">
        <transition name="fade">
          <div class="wrapper" v-if="$parent.textPageTitle">
            <div class="content">
              <div class="desc" v-html="$parent.textPageContent"></div>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </main>
</template>
<script>
export default {
  name: "TextPage",
  props: [],
  components: {},
  data: function () {
    return {};
  },
  mounted() {
    this.$parent.getTextPageContent(
      this.$route.params.id.replace(/\//g, "").replace(/ /g, "-")
    );
  },
  methods: {},
};
</script>
